import { assign, setup } from 'xstate5';

// ─────────────────────────────────────────────────────────────────────────────

export const interactedProductsMachine = setup({
  types: {
    context: {} as Context,
    events: {} as Event,
  },
}).createMachine({
  id: 'interacted-products',
  context: {
    interactedProductIds: [],
  },
  on: {
    ADD_INTERACTED_PRODUCT: {
      actions: assign({
        interactedProductIds: ({ context, event }) => {
          if (context.interactedProductIds.includes(event.productId)) {
            return context.interactedProductIds;
          }

          return [...context.interactedProductIds, event.productId];
        },
      }),
    },
    REMOVE_INTERACTED_PRODUCT: {
      actions: assign({
        interactedProductIds: ({ context, event }) => {
          if (!context.interactedProductIds.includes(event.productId)) {
            return context.interactedProductIds;
          }

          return context.interactedProductIds.filter((productId) => productId !== event.productId);
        },
      }),
    },
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Context = {
  interactedProductIds: readonly string[];
};

type Event =
  | { type: 'ADD_INTERACTED_PRODUCT'; productId: string }
  | { type: 'REMOVE_INTERACTED_PRODUCT'; productId: string };
